module.exports = __webpack_public_path__ + "img/virl.eabf4995.png";